
import { STATE_LOCATION, STATE_ORDER_DRIVER } from "../../Constants/actionTypes";
import { AppDispatch } from "../Reducers";

export const stateLocation =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: STATE_LOCATION,
        payload: data
      });
    } catch (error) {
    }
  };

export const stateOrderDriver =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: STATE_ORDER_DRIVER,
        payload: data
      });
    } catch (error) {
    }
  };